// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/@angular/material/prebuilt-themes/deeppurple-amber.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-select {
  position: relative;
  width: 100%;
  text-align: center;
  color: white;
}
.date-select .hidden-date-input {
  opacity: 0;
  left: -50px;
  width: 100px;
  pointer-events: none;
  position: absolute;
}
.date-select .date-input {
  position: relative;
  display: inline-block;
  width: 152px;
  height: 30px;
  text-align: center;
  overflow: visible;
}
.date-select .ngx-dates-picker-input {
  position: absolute;
  opacity: 0;
  left: 0;
  top: 0;
  width: 100% !important;
  box-sizing: border-box;
  cursor: pointer;
}
.date-select .simple-date-picker {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  padding-top: 6px;
  cursor: pointer;
}
.date-select .big {
  font-size: 1.1em;
  vertical-align: top;
  line-height: 16px;
}
.date-select .date {
  font-size: 1em;
}
.date-select .date-button {
  font-size: 32px;
  cursor: pointer;
}
@media (hover: hover) {
  .date-select .date-button:hover {
    color: var(--motes-gold);
  }
}
.date-select .date-button:not(:active) {
  animation-name: clickAnim;
  animation-duration: 1.2s;
}
@keyframes clickAnim {
  1% {
    color: var(--motes-gold);
  }
}
.date-select .ngx-dates-picker-calendar-container {
  color: rgb(43, 43, 43);
  left: -50% !important;
  z-index: 2;
  width: auto;
  box-sizing: border-box;
  padding-right: 30px;
  width: 320px;
}
.date-select .time-row {
  margin-top: 12px;
  display: block;
}
.date-select .time-input {
  display: inline-block;
  margin: auto;
  margin-top: 0px;
  margin-bottom: 4px;
  border-radius: 3px 0px 0px 3px;
  background-color: rgb(255, 255, 255);
  border: 1px solid white;
  width: 180px;
  height: 26px;
  box-sizing: border-box;
}
.date-select .time-input input {
  height: 26px;
  line-height: 26px;
  background-color: rgba(255, 255, 255, 0);
  border: none;
  padding: 0px;
  font-size: 1em;
  font-family: "Century Gothic", Gothic, sans-serif;
  box-sizing: border-box;
}
.date-select .now-button {
  display: inline-flex;
  color: white;
  height: 26px;
  width: 26px;
  padding: 0;
  margin: 0;
  font-size: 1em;
  border: none;
  margin-left: 0px;
  border-radius: 0px 3px 3px 0px;
  background-color: var(--motes-blue);
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
}

input[type=time]::-webkit-clear-button {
  display: none;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/date-select/date-select.component.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AAAJ;AAEI;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AAAR;AAGI;EACI,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AADR;AAII;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;AAFR;AAKI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,gBAAA;EACA,eAAA;AAHR;AAMI;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;AAJR;AAOI;EACI,cAAA;AALR;AAQI;EACI,eAAA;EACA,eAAA;AANR;AAUI;EACI;IACI,wBAAA;EARV;AACF;AAYI;EACI,yBAAA;EACA,wBAAA;AAVR;AAaK;EACI;IAAK,wBAAA;EAVZ;AACF;AAYI;EACI,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AAVR;AAaI;EACI,gBAAA;EACA,cAAA;AAXR;AAcI;EACI,qBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,oCAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;AAZR;AAcQ;EACI,YAAA;EACA,iBAAA;EACA,wCAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,iDAAA;EACA,sBAAA;AAZZ;AAoBI;EACI,oBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,mCAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAlBR;;AAsBA;EACI,aAAA;AAnBJ","sourcesContent":["@import '@angular/material/prebuilt-themes/deeppurple-amber.css';\n\n.date-select {\n    position: relative;\n    width: 100%;\n    text-align: center;\n    color: white;\n    \n    .hidden-date-input {\n        opacity: 0;\n        left: -50px;\n        width: 100px;\n        pointer-events: none;\n        position: absolute;\n    }\n\n    .date-input {\n        position: relative;\n        display: inline-block;\n        width: 152px;\n        height: 30px;\n        text-align: center;\n        overflow: visible;\n    }\n    \n    .ngx-dates-picker-input {\n        position: absolute;\n        opacity: 0;\n        left: 0;\n        top: 0;\n        width: 100% !important;\n        box-sizing: border-box;\n        cursor:pointer;\n    }\n    \n    .simple-date-picker {\n        position: absolute;\n        width: 100%;\n        left: 0;\n        top: 0;\n        padding-top: 6px;\n        cursor: pointer;\n    }\n    \n    .big {\n        font-size: 1.1em;\n        vertical-align: top;\n        line-height: 16px;\n    }\n    \n    .date {\n        font-size: 1em;\n    }\n    \n    .date-button {\n        font-size: 32px;\n        cursor: pointer;\n    }\n    \n    // Only show hover on desktop\n    @media(hover: hover) {\n        .date-button:hover {\n            color: var(--motes-gold);\n        }\n    }\n    \n    // Enylate hover / click css\n    .date-button:not(:active) {\n        animation-name: clickAnim;\n        animation-duration: 1.2s;\n     }\n\n     @keyframes clickAnim {\n         1% { color: var(--motes-gold) }\n     }\n    \n    .ngx-dates-picker-calendar-container {\n        color:rgb(43, 43, 43);\n        left: -50%!important;\n        z-index: 2;\n        width: auto;\n        box-sizing: border-box;\n        padding-right: 30px;\n        width: 320px;\n    }\n    \n    .time-row {\n        margin-top: 12px;\n        display: block;\n    }\n    \n    .time-input {\n        display: inline-block;\n        margin: auto;\n        margin-top: 0px;\n        margin-bottom: 4px;\n        border-radius: 3px 0px 0px 3px;\n        background-color: rgb(255, 255, 255);\n        border: 1px solid white;\n        width: 180px;\n        height: 26px;\n        box-sizing: border-box;\n        \n        input {\n            height: 26px;\n            line-height: 26px;\n            background-color: rgba(255, 255, 255, 0);\n            border: none;\n            padding: 0px;\n            font-size: 1em;\n            font-family: \"Century Gothic\", Gothic, sans-serif;\n            box-sizing: border-box;\n        }\n    }\n    // Hide the clock to select time\n    // input[type=\"time\"]::-webkit-calendar-picker-indicator {\n    //     background: none;\n    // }\n    \n    .now-button {\n        display: inline-flex;\n        color: white;\n        height: 26px;\n        width: 26px;\n        padding: 0;\n        margin: 0;\n        font-size: 1em;\n        border: none;\n        margin-left: 0px;\n        border-radius: 0px 3px 3px 0px;\n        background-color: var(--motes-blue);\n        box-sizing: border-box;\n        justify-content: center;\n        align-items: center;\n    }\n}\n\ninput[type=\"time\"]::-webkit-clear-button {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
